<template>
  <div style="min-height: calc(100vh - 176px)" class="flex flex-wrap mt-4 relative">
    <!-- Loading Overlay -->
    <div
      v-if="isSaving"
      class="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-50"
    >
      <div class="flex flex-col items-center">
        <svg class="animate-spin h-10 w-10 text-blue-500 mb-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span class="text-gray-700 font-medium">Сохранение...</span>
      </div>
    </div>

    <div
      class="relative py-2 px-2 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0"
      style="min-height: calc(-176px + 100vh);"
    >
      <div class="container mx-auto px-4 py-4">
        <div v-if="!isEditing" class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">Тип контента</label>
          <select 
            v-model="selectedContentType"
            @change="handleContentTypeChange"
            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          >
            <option v-for="option in contentTypeOptions" :key="option.value" :value="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>
        <h1 class="text-2xl font-bold mb-4">
          {{ isEditing ? "Редактировать" : "Создать" }}
          <span v-if="effectiveContentType === 'law'">Закон</span>
          <span v-else-if="effectiveContentType === 'news'">Новость</span>
          <span v-else-if="effectiveContentType === 'science'">Наука</span>
          <span v-else-if="effectiveContentType === 'contest'">Соревнованиях/Конкурсы/Турниры</span>
          <span v-else-if="effectiveContentType === 'uav_catalog'">Каталог продукции БПЛА</span>
        </h1>
        <form @submit.prevent="saveContent" class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">Заголовок</label>
            <input
              type="text"
              v-model="content.title"
              placeholder="Введите заголовок"
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
            />
          </div>
          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">Содержание (HTML)</label>
            <VueEditor v-model="content.content" :editor-options="editorOptions" />
          </div>
          <div v-if="effectiveContentType === 'law'" class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">Прикрепить файл</label>
            <input type="file" @change="handleFileUpload" />
            <p v-if="fileName" class="text-sm text-gray-600 mt-2">Файл: {{ fileName }}</p>
            <div v-if="content.file_attachment && !file" class="mt-2">
              <a
                :href="content.file_attachment"
                target="_blank"
                class="inline-flex items-center text-blue-600 hover:underline text-sm"
              >
                📎 {{ getFileName(content.file_attachment) }}
              </a>
            </div>
          </div>
          <div v-if="effectiveContentType === 'news' 
          || effectiveContentType === 'science'
          || effectiveContentType === 'uav_catalog'
          || effectiveContentType === 'contest'
            " class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">Preview Изображение</label>
            <input type="file" @change="handleImageUpload" accept="image/*" />
            <div v-if="imagePreview" class="mt-2">
              <img :src="imagePreview" alt="Preview" class="w-32 h-32 object-cover rounded" />
            </div>
          </div>
          <div v-if="
          effectiveContentType === 'news'
          || effectiveContentType === 'science'
          || effectiveContentType === 'uav_catalog'
          || effectiveContentType === 'law'
         " class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">Категория</label>
            <select
              v-model="content.category"
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            >
              <option v-for="cat in categories" :key="cat.id" :value="cat.id">
                {{ cat.name }}
              </option>
            </select>
          </div>
          <div v-if="effectiveContentType === 'uav_catalog' && content.uav_catalog" class="mb-4">
            <h3 class="text-lg font-bold mb-4">Информация о продукции БПЛА</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label class="block text-gray-700 text-sm font-bold mb-2">Производитель</label>
                <input
                  v-model="content.uav_catalog.manufacturer"
                  type="text"
                  placeholder="Производитель"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
              <div>
                <label class="block text-gray-700 text-sm font-bold mb-2">Стоимость</label>
                <input
                  v-model="content.uav_catalog.cost"
                  type="number"
                  step="0.01"
                  min="0"
                  placeholder="Стоимость"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
              <div>
                <label class="block text-gray-700 text-sm font-bold mb-2">Назначение</label>
                <input
                  v-model="content.uav_catalog.purpose"
                  type="text"
                  placeholder="Назначение"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
              <div>
                <label class="block text-gray-700 text-sm font-bold mb-2">Поставщик</label>
                <input
                  v-model="content.uav_catalog.supplier"
                  type="text"
                  placeholder="Поставщик"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
            </div>
          </div>
          <div v-if="isEditing" class="mb-4">
            <p class="text-gray-600">Дата создания: {{ this.content.created_at }}</p>
          </div>
          <div class="flex gap-2">
            <button
              type="submit"
              :disabled="isSaving"
              class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {{ isSaving ? 'Сохранение...' : 'Сохранить' }}
            </button>
            <button
              type="button"
              @click="goBack"
              :disabled="isSaving"
              class="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Назад
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API_NEWS, HEADERS_TOKEN_JSON_FILE, HEADERS_TOKEN_JSON } from '@/const/uri';
import { VueEditor } from "vue3-editor";

export default {
  name: 'ContentEdit',
  props: {
    contentType: {
      type: String,
      default: ''
    }
  },
  components: {
    VueEditor,
  },
  data() {
    return {
      editorOptions: {
        placeholder: "Введите текст...",
      },
      content: {
        title: '',
        content: '',
        category: '',
        application: '',
        created_at: null,
        slug: '',
        content_type: {
          key: '',
          val: '',
        },
        uav_catalog: {
          manufacturer: '',
          cost: '',
          purpose: '',
          supplier: ''
        }
      },
      isEditing: false,
      selectedContentType: this.contentType || 'law',
      contentTypeOptions: [
        { label: 'Закон', value: 'law' },
        { label: 'Новость', value: 'news' },
        { label: 'Наука', value: 'science' },
        { label: 'Соревнованиях/Конкурсы/Турниры', value: 'contest' },
        { label: 'Каталог продукции БПЛА', value: 'uav_catalog' }
      ],
      categories: [],
      file: null,
      fileName: null,
      image: null,
      imagePreview: null,
      isSaving: false
    };
  },
  mounted() {
    if (this.$route.query.type) {
      this.selectedContentType = this.$route.query.type;
      this.fetchCategories();
    }
    if (this.$route.params.slug) {
      this.fetchContent();
    }
  },
  computed: {
    effectiveContentType() {
      return this.isEditing ? this.content.content_type.key : this.selectedContentType;
    }
  },
  watch: {
    '$route.params.slug': {
      handler(newSlug, oldSlug) {
        if (newSlug && newSlug !== oldSlug) {
          this.fetchContent();
        } else if (!newSlug && oldSlug) {
          this.resetForm();
        }
      }
    }
  },
  methods: {
    async fetchCategories() {
      try {
        const response = await axios.get(API_NEWS.category, {
          params: {
            content_type: this.selectedContentType,
          },
          headers: HEADERS_TOKEN_JSON(),
        });
        if (response.data.code === 0) {
          this.categories = response.data.data.results || response.data.data;
        }
      } catch (error) {
        console.error("Ошибка загрузки категорий:", error);
      }
    },
    handleContentTypeChange() {
      if ([
        'news', 'science', 'uav_catalog', 'law',
      ].includes(this.selectedContentType)) {
        this.fetchCategories();
      }
    },
    handleFileUpload(event) {
      this.file = event.target.files[0];
      this.fileName = this.file ? this.file.name : null;
    },
    handleImageUpload(event) {
      this.image = event.target.files[0];
      this.imagePreview = URL.createObjectURL(this.image);
    },
    async fetchContent() {
      const slug = this.$route.params.slug;
      if (!slug) return;
      try {
        const response = await axios.get(`${API_NEWS.base}${slug}/`, { headers: HEADERS_TOKEN_JSON() });
        if (response.data.code === 0) {
          this.content = response.data.data;
          this.selectedContentType = this.content.content_type.key;

          // Initialize uav_catalog if not present
          if (!this.content.uav_catalog) {
            this.content.uav_catalog = {
              manufacturer: '',
              cost: '',
              purpose: '',
              supplier: ''
            };
          }

          if (this.content.image) {
            this.imagePreview = this.content.image;
          }
          if (this.content.file_attachment) {
            this.fileName = this.content.file_attachment.split('/').pop();
          }
          this.isEditing = true;
        }
        if ([
          'news', 'science', 'uav_catalog', 'law',
        ].includes(this.selectedContentType)) {
          this.fetchCategories();
        }
      } catch (error) {
        console.error('Ошибка загрузки данных:', error);
      }
    },
    getFileName(url) {
      return decodeURIComponent(url.split('/').pop());
    },
    goBack() {
      const contentType = this.$route.params.type || this.content.content_type?.key || this.selectedContentType;
      this.$router.push(`/admin/content/${contentType}`);
    },
    resetForm() {
      this.content = {
        title: '',
        content: '',
        category: '',
        application: '',
        created_at: null,
        slug: '',
        content_type: {
          key: '',
          val: '',
        },
        uav_catalog: {
          manufacturer: '',
          cost: '',
          purpose: '',
          supplier: ''
        }
      };
      this.isEditing = false;
      this.file = null;
      this.fileName = null;
      this.image = null;
      this.imagePreview = null;
      if (this.$route.query.type) {
        this.selectedContentType = this.$route.query.type;
        this.fetchCategories();
      }
    },
    async saveContent() {
      if (this.isSaving) return;
      this.isSaving = true;

      let formData = new FormData();
      formData.append('title', this.content.title);
      formData.append('content', this.content.content);
      formData.append('slug', this.content.slug);
      if (this.file) {
        formData.append('file_attachment', this.file);
      }
      if (this.image) {
        formData.append('image', this.image);
      }
      if ([
        'news', 'science', 'uav_catalog', 'law',
      ].includes(this.selectedContentType)) {
        formData.append('category', this.content.category);
      }
      // Only send uav_catalog data if this is a UAV catalog item
      if (this.effectiveContentType === 'uav_catalog' && this.content.uav_catalog) {
        formData.append('uav_catalog', JSON.stringify(this.content.uav_catalog));
      }
      try {
        if (this.isEditing) {
          formData.append('content_type', this.content.content_type.key);
          const slug = this.$route.params.slug;
          await axios.put(`${API_NEWS.base}${slug}/`, formData, {
            headers: HEADERS_TOKEN_JSON_FILE(),
          });
        } else {
          formData.append('content_type', this.selectedContentType);
          const response = await axios.post(API_NEWS.base, formData, {
            headers: HEADERS_TOKEN_JSON_FILE(),
          });
          if (response.data.code === 0) {
            const newSlug = response.data.data.id;
            this.content.slug = newSlug;
            this.content.content_type = { key: this.selectedContentType, val: '' };
            this.isEditing = true;
            this.$router.replace({
              name: 'ContentEditDetail',
              params: { slug: newSlug }
            });
          }
        }
      } catch (error) {
        console.error('Ошибка сохранения:', error);
      } finally {
        this.isSaving = false;
      }
    }
  },
};
</script>
